import React, { useState, useEffect, useCallback } from 'react'
import AccountsService from '../../../services/accounts.service'
import '../../../styles/statement.css'
import moment from 'moment'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import Pagination from 'react-js-pagination'
import { carouselCurrentItemSelector } from '../../../selectors'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import UserIcon from 'custom/assets/common-icons/User.svg'
import CreditIcon from 'custom/assets/accounts/up_Arrow.svg'
import DebitIcon from 'custom/assets/accounts/down_arrow.svg'
import NumberFormat from 'react-number-format'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import { ACCOUNT_KEYS, MENU_SIDEBAR_KEYS } from '../../../utils/translation-constants'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { useHistory, useLocation } from 'react-router-dom'
import Loading from 'custom/assets/loaders/Loading'
import config from 'custom/config/environment'
import DownloadIcon from 'custom/assets/common-icons/Download.svg'

export default function MonthlyStatement({ month = '', customFromDate, customToDate }) {
  const location = useLocation()
  const history = useHistory()
  const [loader, setLoader] = useState(false)
  const [downloadLoader, setDownloadLoader] = useState(false)
  const [detailStatementList, setDetailStatementList] = useState([])
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [expanded, setExpanded] = useState(null)
  const [fromDate, setFromDate] = useState(customFromDate || null)
  const [toDate, setToDate] = useState(customToDate || null)
  const [currentPage, setCurrentPage] = useState(1)
  const [stage, setStage] = useState(0)
  const pageLimit = 10
  // const[month, setMonth] = useState(location?.state?.month || "");
  // const [breadCum, setBreadCum] = useState(location?.state?.breadCum || "");
  const { t } = useTranslation()

  useEffect(() => {
    if (month !== '') {
      getFullStatementFor(month)
    }
    if (fromDate !== null && toDate !== null) {
      getStatementForDate()
    }
  }, [currentAccountDetail])

  const getFullStatementFor = async (months) => {
    try {
      setLoader(true)
      setExpanded(null)
      let response = undefined
      setFromDate(
        moment()
          .subtract(months != 1 && months, 'month')
          .startOf('month')
          .format('YYYY-MM-DD'),
      )
      setToDate(
        moment()
          .subtract(months != 1 && 1, 'month')
          .endOf('month')
          .format('YYYY-MM-DD'),
      )

      if (months == 1) {
        response = await AccountsService.getCurrentMonthTransactions(
          currentAccountDetail.accountNo,
          currentAccountDetail.custNo,
        )
      } else if (months == 2) {
        response = await AccountsService.getLast2MonthTransactions(
          currentAccountDetail.accountNo,
          currentAccountDetail.custNo,
          months,
        )
      } else if (months == 3) {
        response = await AccountsService.getLast3MonthTransactions(
          currentAccountDetail.accountNo,
          currentAccountDetail.custNo,
          months,
        )
      }
      if (response.items != null && response.items.length) {
        const tempList = await response.items.map((value) => {
          value = {
            ...value,
            groupdate: new Date(value.date).toISOString().slice(0, 7),
          }
          return value
        })
        setDetailStatementList(tempList)
        sliceDetailedStatement(1, tempList)
        setLoader(false)
        setStage(1)
      } else {
        setDetailStatementList([])
        setStage(1)
        setLoader(false)
      }
    } catch (e) {
      setLoader(false)
    }
  }

  const getStatementForDate = async () => {
    // !: fetches statements in range of fromdate and todate
    try {
      if (!fromDate || !toDate) {
        return
      }
      setLoader(true)
      const response = await AccountsService.getTransactionsForDate({
        accountNumber: currentAccountDetail.accountNo,
        custId: currentAccountDetail.custNo,
        fromDate: fromDate,
        toDate: toDate,
      })
      if (response.items != null && response.items.length) {
        const tempList = await response.items.map((value) => {
          value = {
            ...value,
            groupdate: new Date(value.date).toISOString().slice(0, 7),
          }
          return value
        })
        setDetailStatementList(tempList)
        sliceDetailedStatement(1, tempList)
        setLoader(false)
        setStage(1)
      } else {
        setDetailStatementList([])
        setStage(1)
        setLoader(false)
      }
    } catch (e) {
      setLoader(false)
    }
  }

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setExpanded(null)
      setSlicedDetailStatementList(x)
    } else {
    }
  }, []) //currentPage
  const downloadStatement = async (data) => {
    try {
      setDownloadLoader(true)
      let fdate = new Date(fromDate).toISOString().split('T')[0]
      let tdate = new Date(toDate).toISOString().split('T')[0]
      await AccountsService.getPDFStatement(fdate, tdate, currentAccountDetail.custNo, data.value)
      setDownloadLoader(false)
    } catch (err) {
      setDownloadLoader(false)
    }
  }
  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderDeatils()
      default:
        return renderDeatils()
    }
  }
  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }
  function renderDeatils() {
    return (
      <div>
        {/* {loader && <NeoLoader />} */}
        {!loader && !detailStatementList.length && (
          <div className='text-center'>No Transactions Found</div>
        )}
        {!loader && detailStatementList && detailStatementList.length > 0 && (
          <React.Fragment>
            <div className='d-flex justify-content-between pt-4'>
              <div className='statement-list-title font-weight-bold'>
                {new Date(fromDate).toLocaleString('default', {
                  month: 'long',
                })}
                {new Date(fromDate).getMonth() != new Date(toDate).getMonth() &&
                  `-${new Date(toDate).toLocaleString('default', {
                    month: 'long',
                  })}`}
                {' Statement'}
              </div>
              <div id='dropdown' style={{ position: 'relative' }}>
                <button
                  type='button'
                  className='btn p-2 detailed-statement-btn d-flex justify-content-around'
                  style={{ fontSize: 10, outline: 'none' }}>
                  <img src={DownloadIcon} alt='' className='mr-2' height={23} width={20} />
                  <span className='font-weight-bold'>
                    {downloadLoader ? (
                      <NeoLoader
                        width={'10px'}
                        height={'10px'}
                        text={t(ACCOUNT_KEYS.TRANSACTION_TABS_KEYS.DOWNLOADING)}
                      />
                    ) : (
                      <p>{t(ACCOUNT_KEYS.TRANSACTION_TABS_KEYS.DOWNLOAD_STATEMENT)}</p>
                    )}
                  </span>
                </button>
                <div className='dropdown-content'>
                  {config.FORMAT_LIST.map((option, index) => (
                    <div onClick={() => downloadStatement(option)} key={index} value={option.value}>
                      {option.title}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {slicedDetailStatementList.length &&
              slicedDetailStatementList.map((stmnt, i) => (
                <div key={i}>
                  {(i === 0 ||
                    (i > 0 && stmnt.groupdate !== slicedDetailStatementList[i - 1].groupdate)) && (
                    <div className='font-weight-600' style={{ fontSize: 8 }}>
                      {new Date(stmnt.groupdate).toLocaleString('default', {
                        month: 'long',
                      })}
                      {' ' + new Date(stmnt.groupdate).getFullYear()}
                    </div>
                  )}
                  <div key={i} className='statement-item'>
                    <div
                      className='d-flex justify-content-between font-weight-600'
                      onClick={() => (expanded == i ? setExpanded(null) : setExpanded(i))}>
                      <div className='d-flex'>
                        <div className='mr-3'>
                          <img src={UserIcon} alt='user icon' className='user-icon p-2' />
                        </div>
                        <div>
                          <div className='statement-desc'>{stmnt.txnTypeDes}</div>
                          <div className='statement-date-time'>
                            {moment(stmnt.date).format('DD-MM-YYYY')}
                          </div>
                        </div>
                      </div>
                      <div className='text-right'>
                        <div>
                          <span className='statement-currency mr-1'>{stmnt.txncurrency}</span>
                          <span className='statement-amount' style={{ marginRight: 10 }}>
                            <NumberFormat
                              value={stmnt?.amount}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={''}
                              fixedDecimalScale={true}
                              decimalScale={2}
                              allowEmptyFormatting
                            />
                          </span>
                          {stmnt.debitOrCredit == 'Debit' ? (
                            <img height={'15'} src={DebitIcon} alt='' />
                          ) : (
                            <img
                              src={CreditIcon}
                              alt=''
                              height={'15'}
                              style={{ transform: 'rotateZ(180deg)' }}
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    {expanded == i && (
                      <div className='ml-2 mt-3'>
                        <div className='row my-2'>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.REF)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.referenceNumber || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.EXPENSE_KEYS.NARRATION)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.narration || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.EXPENSE_KEYS.INSTRUMENT_CODE)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.instrumentCode || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.EXPENSE_KEYS.SERIAL_NUMBER)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.slNo || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.DEBIT_CREDIT)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.debitOrCredit || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.BRANCH)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.branch || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.TXN_TYPE)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.txnTypeDes || '-'}
                            </div>
                          </div>
                          <div className='col-4'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.DATE)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.date || '-'}
                            </div>
                          </div>
                        </div>
                        <div className='row my-2'>
                          <div className='col-12'>
                            <div className='statement-expanded-label font-weight-500'>
                              {t(ACCOUNT_KEYS.TRANSACTION_DETAILS_KEYS.REMARK)}
                            </div>
                            <div className='statement-expanded-value font-weight-bold'>
                              {stmnt.remarks || '---'}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

            <div className='d-flex justify-content-center mb-5 mt-2'>
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={10}
                totalItemsCount={detailStatementList.length}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={(page) => sliceDetailedStatement(page, detailStatementList)}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
  return (
    <div>
      {/* <LayoutWithAccountCard breadCumKey={breadCum}> */}
      <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={StatementIcon} alt='statement icon' />
          </div>
          <div className='title-spacing'>
            <span className='font-weight-bold'>{t(MENU_SIDEBAR_KEYS.DETAILED_STATEMENT)}</span>
            <span className='header-title-section'>
              <p>View and Download your statement</p>
            </span>
          </div>
        </div>
      </div>
      <div>{renderSwitch()}</div>
      {/* </LayoutWithAccountCard> */}
    </div>
  )
}
